import { action, observable } from 'mobx';
import { PumpsNoteEditForm } from 'application/pumps/forms';
import {BaseEditViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import { FacilityService } from 'application/facility/services';

@applicationContext
class PumpsNoteEditViewStore extends BaseEditViewStore {
    @observable accessor note = null;
    constructor(rootStore, componentProps) {
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'pumpsNote',
            id: componentProps && componentProps.facilityId,
            Form: PumpsNoteEditForm,
            actions: () => {
                return {
                    get: async (facilityId, opts) => {
                        const response = await facilityService.get(facilityId, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await facilityService.updatePumpsNote(resource);
                        return response.data;
                    }
                }
            },
            FormClass: PumpsNoteEditForm
        });

        this.facilityId = componentProps && componentProps.facilityId;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            await setTimeout(() => this.rootStore.notificationStore.success("PUMPS.EDIT.NOTE_SUCCESS"));
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default PumpsNoteEditViewStore;
